import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  mainDiv: {
    display: "flex",
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    background: colors.white,
    overflowX: "hidden",
    boxSizing: "border-box",
  },
  container: {
    display: "flex",
    background: colors.white,
    flexDirection: "row",
    alignSelf: "stretch",
    borderRadius: 0,
    boxSizing: "border-box",
    height: "100%",
    width: "100%",
  },
  leftBox: {
    flex: "1 0 0",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
    padding: 0,
  },
  rightBox: {
    flex: 1,
    background: colors.white,
    display: "flex",
    padding: "48px",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    height: "100%",
    width: "100%",
    "@media (max-width: 600px)": {
      padding: "32px",
    },
    "@media (min-width: 1200px)": {
      padding: "64px",
    },
  },
}));

export default styles;
